import React from "react";
import { CoRetrieveDocumentData } from "../../components/generic/CoRetrieveDocumentData";
import { DocumentNotValidError } from "../../components/generic/DocumentNotValidError";
import { DocumentProperties } from "../../components/cpm/DocumentProperties/DocumentProperties";
import { UserFunctionEnum } from "../../api/models/user-function-enum";
import { UnauthorizedError } from "../../components/generic/UnauthorizedError";
import { ProtectedComponent } from "../../components/wrappers/ProtectedComponent";
export const DocumentPropertiesPage: React.FunctionComponent = () => {
  return (
    <ProtectedComponent userFunction={UserFunctionEnum.MENU_DOCUMENT_OUTLINE} errorComponent={<UnauthorizedError />}>
      <CoRetrieveDocumentData shouldFetchDocumentPart={true} isSilent={true}>
        {({ coObject, documentPart }) =>
          coObject?.documentId ? (
            <DocumentProperties idPartRoot={coObject.documentId} documentPart={documentPart} />
          ) : (
            <DocumentNotValidError />
          )
        }
      </CoRetrieveDocumentData>
    </ProtectedComponent>
  );
};
